<template>
  <section>数字生态</section>
</template>
<script>
export default {
  data() {
    return {
      // centerDialogVisible: "true",
    };
  },
  watch: {},
  created() {},
  mounted() {
    alert("栏目装修中，请您耐心等待~");
    this.$router.go(-1);
  },
  methods: {},
};
</script>
<style lang="less" scoped></style>
